import React, { useRef, useState } from "react";
import { Dialog } from "@mui/material";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import ServiceListComponent from "./ServiceListComponent";
import styles from "./styles.module.scss";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const ServiceOrderDialog = ({ params, ...restProps }) => {
  const {
    dropdownData,
    isOpen,
    setIsOpen,
    rows = [],
    saveHandler,
    rowForm,
    setRowForm,
    listing,
    deleteItemHandler,
  } = restProps;

  const [serviceRowList, setServiceRowList] = useState(rows);
  const ref = useRef();
  const isViewMode = isOpen?.mode === "view";

  const createUpdateHandler = async (serviceRowForm) => {
    try {
      const isItemNoUnique = !serviceRowList.some(
        (row) => row.Item_no === serviceRowForm.Item_no
      );
      // setLoading(true);
      if (isItemNoUnique && serviceRowForm?.isNew) {
        const tempRowList = [
          ...serviceRowList,
          { ...serviceRowForm, isNew: false, Item_no: rowForm?.Item_no },
        ];
        setServiceRowList(tempRowList);
        saveHandler(tempRowList);
      } else {
        let p = [...serviceRowList];
        p[serviceRowForm?.Item_no - 1] = { ...serviceRowForm, isNew: false };
        setServiceRowList(p);
        saveHandler(p);
      }
      ref.current.stopEditing();
    } catch (e) {
    } finally {
      // setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={!!isOpen}
        PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
      >
        <div className={`${styles["select-concession-popup"]}`}>
          <div className="d-flex " style={{ justifyContent: "space-between" }}>
            <div className="heading-4 color-dark">Service Item</div>
            {!isViewMode && (
              <div className="mx-4">
                <AButton
                  variant="primary_filled"
                  onClick={() => ref.current.addNewRow()}
                  size="xs"
                >
                  Add new
                </AButton>
              </div>
            )}
            <div style={{ marginLeft: "auto" }}>
              <CrossIcon
                width={24}
                height={24}
                onClick={() => {
                  setIsOpen(null);
                }}
              />
            </div>
          </div>

          <div>
            <ServiceListComponent
              dropdownData={dropdownData}
              ref={ref}
              createUpdateHandler={createUpdateHandler}
              rows={serviceRowList}
              rowForm={rowForm}
              setRowForm={setRowForm}
              isViewMode={isViewMode}
              listing={listing}
              deleteItemHandler={deleteItemHandler}
            />
            <div className="mt-3">
              <AButton
                variant="primary_filled"
                onClick={() => {
                  setIsOpen(false);
                }}
                size="xs"
              >
                Done
              </AButton>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ServiceOrderDialog;
